const DOCUMENT_PUNCTUATION_REGEX = /[-)./(+ ]/g;
const NON_DIGITS_REGEX = /\D/g;
const NON_ALPHA_NUMERIC_REGEX = /[^0-9A-Z]/gi;

export const NATURAL_DOCUMENT_LENGTH = 11;
export const LEGAL_DOCUMENT_LENGTH = 14;
export const LEGAL_DOCUMENT_BODY_LENGTH = 12;

export const normalizeDocument = (value: string): string =>
  (value || '').replace(DOCUMENT_PUNCTUATION_REGEX, '').toUpperCase();

export const normalizeNaturalDocument = (value: string): string =>
  normalizeDocument(value)
    .replace(NON_DIGITS_REGEX, '')
    .substring(0, NATURAL_DOCUMENT_LENGTH);

export const normalizeLegalDocument = (value: string): string =>
  normalizeDocument(value)
    .replace(NON_ALPHA_NUMERIC_REGEX, '')
    .substring(0, LEGAL_DOCUMENT_LENGTH);

export const isLegalDocumentLike = (value: string): boolean => {
  const normalized = normalizeDocument(value);

  return (
    /[A-Z]/.test(normalized) ||
    normalized.replace(NON_DIGITS_REGEX, '').length > NATURAL_DOCUMENT_LENGTH
  );
};

export const normalizeStoredDocument = (value: string): string =>
  isLegalDocumentLike(value)
    ? normalizeLegalDocument(value)
    : normalizeNaturalDocument(value);
